import {
	CartSelection, useCart, formatCurrency,
} from './cart';
import { useUser } from './user';
import { useVGS } from './vgs';
import { safegaurd } from './candidateSafeGaurds';

/**
 * Validate each cart selection has minimum amount.
 * Must be used within global provider.
 */
export const validSelectionAmounts = (): boolean => {
	const min: number = 3;
	const { cart } = useCart();
	const { selections } = cart;
	return Array.from(selections.values()).every((selection) => {
		// general safegaurd check.
		if (!safegaurd(selection)) {
			return false;
		}
		// min check.
		if (selection.amount < min) {
			return false;
		}
		// limit check.
		if (
			selection.contribution_limit
			&& selection.contribution_limit > 0
			&& selection.amount > selection.contribution_limit
		) {
			return false;
		}
		return true;
	});
};

/**
 * Valid contribution amount.
 */
export const validContributionAmountWarning = (selection: CartSelection): string | null => {
	const min: number = 3;
	const { amount, contribution_limit: limit } = selection;
	if (amount < min) {
		return `Minimum contribution is ${formatCurrency(min)}.`;
	}
	if (limit && limit > 0 && amount > limit) {
		return `Maximum contribution is ${formatCurrency(limit)}.`;
	}
	if (selection.candidate_blackout) {
		return 'Candidate is not accepting contributions.';
	}
	return null;
};

/**
 * Validate checkout access.
 * Must be used within global provider.
 */
export const validCheckoutTransition = (): boolean => {
	const { cart } = useCart();
	if (validSelectionAmounts() && cart.selections.size > 0) {
		return true;
	}
	return false;
};

/**
 * Highest level validation status.
 * Validate confirm access.
 * Must be used within global provider.
 */
export const validConfirmTransition = (): boolean => {
	const { validUser } = useUser();
	const { vgsValid } = useVGS();
	if (validCheckoutTransition() && validUser && vgsValid) {
		return true;
	}
	return false;
};
